import React from 'react';
import './AuthenticationForm.less';
import { Form } from '@ant-design/compatible';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Input, Button, Checkbox, message } from 'antd';
import { PasswordResetRequestForm } from './../';
import { ENV_TEST_PASSWORD, ENV_TEST_USER } from './../../config/Environment';
import { LOGIN_ERROR } from './../../actions/Authentication';

const FormItem = Form.Item;

class AuthenticationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resetModalVisible: false,
    };
  }

  /**
   * Action success & errors handling
   * @param prevProps - previous props from earlier state
   */
  componentDidUpdate(prevProps) {
    this.handleActionResponseNotifications(this.props.actionResponse);
  }

  /**
   * Handles notifications for the action response
   * @param actionResponse - the response of the action made
   */
  handleActionResponseNotifications(actionResponse) {
    if (actionResponse === null) {
      return;
    }

    switch (actionResponse.get('type')) {
      case LOGIN_ERROR:
        if (actionResponse.get('status')) {
          message.error('Forkert brugernavn eller password.');
        } else {
          message.error('Der er opstået en fejl, prøv igen.');
        }
        break;

      default:
        break;
    }
    this.props.clearActionResponse();
  }

  /**
   * Validates & submits data to backend
   * @param evt is the submit button.
   */
  handleSubmit = (evt) => {
    evt.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const { username, password, rememberMe } = values;

      this.setState({ error: '' });
      this.props.login(new URLSearchParams({ username, password }), rememberMe);
    });
  };

  /**
   * Shows the window where a user can request to reset his password.
   */
  handleShowResetModal = () => {
    this.setState({
      resetModalVisible: true,
    });
  };

  /**
   * Closes the window where a user can request to reset his password.
   */
  handleHideResetModal = () => {
    this.setState({
      resetModalVisible: false,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className={'login-form'}>
        <FormItem>
          {getFieldDecorator('username', {
            initialValue: ENV_TEST_USER,
            rules: [
              {
                required: true,
                message: 'Indtast venligst email',
                whitespace: true,
              },
            ],
          })(<Input prefix={<UserOutlined className={'icon-input'} />} placeholder={'Email'} />)}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            initialValue: ENV_TEST_PASSWORD,
            rules: [
              {
                required: true,
                message: 'Indtast venligst password.',
                whitespace: true,
              },
            ],
          })(
            <Input
              prefix={<LockOutlined className={'icon-input'} />}
              type={'password'}
              placeholder={'Password'}
            />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('rememberMe', {
            valuePropName: 'checked',
            initialValue: false,
          })(<Checkbox>Husk mig</Checkbox>)}
          <Button type='link' className={'float-right'} onClick={this.handleShowResetModal}>
            Glemt password
          </Button>
          <PasswordResetRequestForm
            visible={this.state.resetModalVisible}
            handleCancel={this.handleHideResetModal}
            isLoading={this.props.isPasswordResetLoading}
            passwordResetRequest={this.props.passwordResetRequest}
            actionResponse={this.props.passwordResetActionResponse}
            clearActionResponse={this.props.clearActionResponse}
          />
          <Button type={'primary'} htmlType={'submit'} className={'login-form-button'}>
            Log in
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default Form.create()(AuthenticationForm);
